<script>
  import Sparkline from "./Sparkline.svelte";
  import TinyMap from "./TinyMap.svelte";

  export let data = [];            // habeas cases [{ court_id, state, date_filed, ... }]
  export let mapping = []; // [{ state_abbreviation: "ca", "state_name": "California", ... }]
  export let courts_mapping = []; // [{ court_id: "akd", "court_name": "District of Alaska", ... }] Note for future refactoring, there might be a way to combine the two mapping JSONs
  export let guff;
  /** @type { [string, string][] } */
  export let court_id_and_map_url_pairs; // [ ["flsd", "assets/flsd-1234.svg"], ... ]

  $: court_id_to_map_url = new Map(court_id_and_map_url_pairs);

  // Takes out Guam, Virgin Islands, Northern Mariana Islands - we can put them back in if cases start to pop off in these places
  const EXCLUDED_TERRITORIES = new Set(['gu','vi', 'mp']);

     // --- Helper functions ---
  const mapAbrevToName = new Map(
    mapping.filter(o => !EXCLUDED_TERRITORIES.has(o.state_abbreviation)).map(o => [o.state_abbreviation, o.state_name])
  ); // maps state abbreviations to state names

  const stateNameToAbbrev = new Map(
    mapping.filter(o => !EXCLUDED_TERRITORIES.has(o.state_abbreviation)).map(o => [o.state_name, o.state_abbreviation])
  ); // maps state namess to state abbreviations

 
  // Removed Guam, Virgin Islands, Northern Mariana Islands from both the data and the courts_mapping data
  $: filteredData = data.filter(d => !EXCLUDED_TERRITORIES.has(d.state));


  $: filteredCourts_mapping = courts_mapping.filter(court => {
  const stateAbbrev = stateNameToAbbrev.get(court.state);
  return stateAbbrev && !EXCLUDED_TERRITORIES.has(stateAbbrev);
});

  // --- Grouping functions ---
  $: habeasByCourt = filteredData.reduce((acc, d) => {
    if (!acc[d.court_id]) acc[d.court_id] = [];
    acc[d.court_id].push(d);
    return acc;
  }, {}); // groups all data by court district (court_id)

  $: habeasByState = filteredData.reduce((acc, d) => {
    if (!acc[d.state]) acc[d.state] = [];
    acc[d.state].push(d);
    return acc;
  }, {}); // groups all data by state (state)


// Loops over the courts_mapping JSON which connects court_id and creates an object with counts of total cases by court districts
// along with the data needed
  $: courtsByState = filteredCourts_mapping.reduce((acc, court) => {

    const stateName = court.state;
    const stateAbbrev = stateNameToAbbrev.get(stateName);



    // if there's no court data still create an object for zero cases

    if (!acc[stateName]) {
      acc[stateName] = {
        state_name: stateName,
        state_abbreviation: stateAbbrev,
        count: 0,
        sparklineData: habeasByState[stateAbbrev] || [],
        courts: []
      };
    }

    const courtCases = habeasByCourt[court.court_id] || [];

    acc[stateName].courts.push({
      court_id: court.court_id,
      court_name: court.court_name,
      count: courtCases.length,
      sparklineData: courtCases
    });

    acc[stateName].count += courtCases.length;



    return acc;
  }, {});

// Map to states but also sort the cases by court and sort the cases by state descending
 $: states = Object.values(courtsByState)
  .map(state => ({
    ...state,
    courts: [...state.courts].sort((a, b) => b.count - a.count)
  }))
  .sort((a, b) => b.count - a.count);


// Toggle hide/show functions - commented out in case we change our minds

//   let openStates = {};

//   function toggleState(stateName) {
//   openStates = {
//     ...openStates,
//     [stateName]: !openStates[stateName]
//   };
// }

 // Text search functions
let textSearch = "";

$: filteredStates = states.filter(state =>
  state.state_name
    .toLowerCase()
    .includes(textSearch.toLowerCase())
);

</script>

<div class="newsapp" style="max-width:40em;margin: var(--spacing3) auto">
<input
  type="search"
  placeholder="Search state"
  bind:value={textSearch}
  class="state_search"
/>
  <table class="table">
    <thead>
      <tr>
        <th colspan="2">State</th>
 
        <th class="right">{guff["total_cases_hed"]}</th>
        <th class="right">{guff["trend_line"]}</th>
      </tr>
    </thead>

    <tbody>
    <!-- Row for each state even the ones with zero cases -->
      {#each filteredStates as state}
        <tr class="state-row">
         <td class="state_stateface"><span class="stateface sf-{state.state_abbreviation}"></span></td>
          <td class="state_name">
            
            {state.state_name}
             <!-- {#if state.courts.length > 1}
  <button on:click={() => toggleState(state.state_name)}>
    {openStates[state.state_name] ? "−" : "+"}
  </button>
{/if} -->

          </td>

          <td class="table__td--numeric">
            {state.count.toLocaleString("en-US")}
          </td>

          <td class="table__td--numeric">
            {#key state.state_name}
             {#if state.sparklineData.length > 1 }
            <Sparkline data={state.sparklineData} type={'state'} />
            {/if}
            {/key}
          </td>
        </tr>
    <!-- Row for each court district if there is a district in that state -->
         {#if state.courts.length > 1 }
  {#each state.courts as court}
    <tr class="district-row">
    <td></td>
      <td class="district-name">
        <span class="tiny-map-wrapper">
          <TinyMap courtAbb={court.court_id} mapUrl={court_id_to_map_url.get(court.court_id)}/>
        </span>
        <span class="court_name">{court.court_name}</span>
      </td>

      <td class="table__td--numeric">{court.count.toLocaleString("en-US")}</td>
      <td class="table__td--numeric">
        {#key court.court_id}
          {#if court.sparklineData.length > 1 }
        <Sparkline data={court.sparklineData} type={'district'}/>
        {/if}
        {/key}
      </td>
    </tr>
  {/each}
{/if}
      {/each}

    </tbody>
  </table>
</div>
<style>
</style>
